import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import CartItem from '@/components/CartItem'
import Undo from '@/components/Undo'
import CartErrors from './CartErrors'

import styles from './styles.module.scss'
import BundleGroup from '@/components/BundleGroup'
import { CartTransformerContext } from '@/store/cartTransformer'
import Shipments from '@/components/Shipments'
import { pushDeliveryGroupings } from '@/utils/analytics'
import { isExtendPostPurchaseItem } from '@/utils/product'
import { CartContext } from '@/store/cart'
const CartSection = ({
    setIsExtendModalVisible,
    sitewidePromo,
    itemRemoved,
    cartTotalItems
}) => {
    const { cart } = useContext(CartContext)
    const { nonBundledCartItems, completeBundles, transformedCartItems, deliveryGroupings } = useContext(CartTransformerContext)
    const productSkus = transformedCartItems ? transformedCartItems.map(item => item.sku) : []

    useEffect(() => {
        pushDeliveryGroupings(deliveryGroupings)
    }, [deliveryGroupings])

    return (
        <div className={styles.cartItems} id='cartSection'>
            <div className={styles.header}>
                <h1 className={styles.mainTitle}>
                    Your cart {`(${cartTotalItems})`}
                </h1>
                {itemRemoved && <Undo itemRemoved={itemRemoved} />}
            </div>
            <CartErrors productSkus={productSkus} />
            { cartTotalItems > 0 && (
                <ul className={styles.itemList}>
                    <>
                        {completeBundles?.length === 0 ? (
                            <Shipments
                                items={nonBundledCartItems}
                                sitewidePromo={sitewidePromo}
                                setIsExtendModalVisible={setIsExtendModalVisible}
                            />
                        ) : (
                            nonBundledCartItems?.map((item) => (
                                <li key={`cart-item-${item.id}`}>
                                    <CartItem
                                        item={item}
                                        sitewidePromo={sitewidePromo}
                                        setIsExtendModalVisible={setIsExtendModalVisible}
                                    />
                                </li>
                            ))
                        )}
                        {completeBundles?.map((bundle, i) => (
                            <BundleGroup
                                key={`bundle-${bundle.productCode}-${i}`}
                                bundledItems={bundle.items}
                                sitewidePromo={sitewidePromo}
                                label={bundle.genericName}
                            >
                                <ul className={styles.itemList}>
                                    {bundle.items.map((item) => (
                                        <li key={`cart-item-${item.id}`}>
                                            <CartItem
                                                item={item}
                                                sitewidePromo={sitewidePromo}
                                                setIsExtendModalVisible={setIsExtendModalVisible}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </BundleGroup>
                        ))}
                    </>

                    {/* Dislay extend item outside of the grouping */}
                    {cart
                        ?.items
                        ?.filter((item) => isExtendPostPurchaseItem(item))
                        ?.map((item) => (
                            <li key={`cart-item-${item.id}`}>
                                <CartItem
                                    item={item}
                                    sitewidePromo={sitewidePromo}
                                    setIsExtendModalVisible={setIsExtendModalVisible}
                                />
                            </li>
                        ))
                    }
                </ul>
            )}
        </div>
    )
}

CartSection.propTypes = {
    setIsExtendModalVisible: PropTypes.func.isRequired,
    sitewidePromo: PropTypes.any,
    itemRemoved: PropTypes.any,
    cartTotalItems: PropTypes.number
}

export default CartSection
